module.exports = __webpack_public_path__ + "assets/029dd39e7ef8e592a3e126134dfc9f21.png";